/**
 * Имя витрины для <title>/меты и JSON-LD Organization.
 * Приоритет: OrganizationName канала (ChannelWebSeoConfig, задаётся в админке)
 * → env NUXT_PUBLIC_SITE_NAME → хост канала (hostLoader) → 'Skuby'.
 *
 * Намеренно plain-getter, а не computed: appConfig на сервере не реактивен,
 * и computed навсегда кэширует первое чтение — если оно случится до того, как
 * hostLoader запишет host (порядок плагинов), имя «застрянет» на fallback.
 * По той же причине ref конфига берётся здесь (setup-контекст), а читается
 * лениво: геттер вызывают при рендере head, вне setup.
 */
export const useSiteName = () => {
  const runtimeConfig = useRuntimeConfig()
  const appConfig = useAppConfig()
  const seoConfig = useSeoConfig()

  return {
    get value(): string {
      return (
        seoConfig.value?.organizationName
        || (runtimeConfig.public.siteName as string)
        || appConfig.host
        || 'Skuby'
      )
    },
  }
}
